import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ppa-home-publico',
  templateUrl: './home-publico.component.html',
  styleUrls: ['./home-publico.component.css']
})
export class HomePublicoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
